import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../core/user.service';

   @Injectable({
     providedIn: 'root'
   })
   export class RequisitionsGuard implements CanActivate {    
    constructor(private userService: UserService, private router: Router) {}
    
    async canActivate(): Promise<boolean> {
      if ((await firstValueFrom(this.userService.getAccessModules())).requisitions) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
    }
   }